// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__1dcTq","title":"Images45_title__vw-hU","images":"Images45_images__uegGT"};